interface BaseSettingsInterface {
    localesSupported: string[]
    tagsSupported: string[]
    baseType: string;
}

interface BaseInterface {
    id: number,
    name: string;
    created: string;
    updated: string;
    lastActivity: string;
    apiBaseUrl: string;
    apiToken?: string;
    settings: BaseSettingsInterface
}

class BaseSettings implements BaseSettingsInterface {
    localesSupported: string[] = [];
    tagsSupported: string[] = [];
    baseType: string;
}

class Base implements BaseInterface {
    static readonly TYPE_CHATOMATIC   = 'chatomatic';
    static readonly TYPE_FLIRTMACHINE = 'flirtmachine';

    apiBaseUrl: string;
    apiToken: string;
    created: string;
    id: number;
    lastActivity: string;
    name: string;
    settings: BaseSettingsInterface = new BaseSettings();
    updated: string;
}

export {
    BaseSettingsInterface,
    BaseInterface,
    BaseSettings,
    Base
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/api.models.ts